import { Component, Inject, Input, ViewChild } from "@angular/core";
import { Person } from "@common/ADAPT.Common.Model/person/person";
import { PersonFlag } from "@common/ADAPT.Common.Model/person/person-flag.enum";
import { AdaptClientConfiguration } from "@common/configuration/adapt-client-configuration";
import { PERSONAL_CONFIGURATION_PAGE } from "@common/page-route-providers";
import { IAdaptRoute } from "@common/route/page-route-builder";
import { BaseComponent } from "@common/ux/base.component/base.component";
import { DismissibleCtaComponent } from "@org-common/lib/call-to-action/dismissible-cta/dismissible-cta.component";

@Component({
    selector: "adapt-theme-prompt-dashboard-element",
    templateUrl: "./theme-prompt-dashboard-element.component.html",
    styles: [":host { display: contents }"],
    standalone: false,
})
export class ThemePromptDashboardElementComponent extends BaseComponent {
    public readonly projectLabel = AdaptClientConfiguration.AdaptProjectLabel;
    public readonly PersonFlag = PersonFlag;

    @Input({ required: true }) public person!: Person;

    @ViewChild(DismissibleCtaComponent) public ctaComponent?: DismissibleCtaComponent;

    constructor(@Inject(PERSONAL_CONFIGURATION_PAGE) private personalConfigurationPageRoute: IAdaptRoute<any>,) {
        super();
    }

    public setTheme() {
        this.personalConfigurationPageRoute.gotoRoute(undefined, { section: "Theme" });
        this.ctaComponent?.dismiss(true);
    }
}
